"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchVacanciesProvider = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var react_1 = __importStar(require("react"));
var query_string_1 = __importDefault(require("query-string"));
var react_router_dom_1 = require("react-router-dom");
var defaultQuery = {
    page: 1,
    availability: [],
    educationalLevels: [],
    distance: 25,
    search: '',
};
var SearchVacanciesContext = react_1.default.createContext({
    query: defaultQuery,
    updateQuery: function () { return undefined; },
});
var useSearchParams = function () {
    var search = (0, react_router_dom_1.useLocation)().search;
    return react_1.default.useMemo(function () { return new URLSearchParams(search); }, [search]);
};
function SearchVacanciesProvider(_a) {
    var children = _a.children;
    var searchParams = useSearchParams();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var _b = (0, react_1.useState)(), vacancies = _b[0], setVacancies = _b[1];
    var _c = (0, react_1.useState)(function () {
        var _a, _b, _c, _d;
        return ({
            address: (_a = searchParams.get('address')) !== null && _a !== void 0 ? _a : defaultQuery.address,
            availability: (_b = searchParams.getAll('availability').map(Number)) !== null && _b !== void 0 ? _b : defaultQuery.availability,
            distance: searchParams.get('distance') ? Number(searchParams.get('distance')) : defaultQuery.distance,
            educationalLevels: (_c = searchParams.getAll('educationalLevels').map(Number)) !== null && _c !== void 0 ? _c : defaultQuery.educationalLevels,
            lat: searchParams.get('lat') ? Number(searchParams.get('lat')) : defaultQuery.lat,
            lng: searchParams.get('lng') ? Number(searchParams.get('lng')) : defaultQuery.lng,
            page: searchParams.get('page') ? Number(searchParams.get('page')) : defaultQuery.page,
            search: (_d = searchParams.get('search')) !== null && _d !== void 0 ? _d : defaultQuery.search,
        });
    }), query = _c[0], setQuery = _c[1];
    var providedQuery = (0, react_1.useMemo)(function () {
        return query_string_1.default.stringify(query);
    }, [query]);
    var fetchVacancies = function (fetchQUery) {
        axios_1.default.post('/data/vacancies', fetchQUery).then(function (response) {
            setVacancies(response.data);
        });
    };
    var updateQuery = (0, react_1.useCallback)(function (newQuery) {
        setQuery(function (prev) {
            var _a;
            // If other parameters are changed we want to reset the pagination back to the first page to avoid the pagination being stuck on page X
            var newPage = (_a = newQuery.page) !== null && _a !== void 0 ? _a : 1;
            var newQueryObject = __assign(__assign(__assign({}, prev), newQuery), { page: newPage });
            fetchVacancies(newQueryObject);
            navigate("?".concat(query_string_1.default.stringify(newQueryObject)));
            return newQueryObject;
        });
    }, [navigate]);
    return (0, jsx_runtime_1.jsx)(SearchVacanciesContext.Provider, __assign({ value: { query: query, providedQuery: providedQuery, vacancies: vacancies, updateQuery: updateQuery } }, { children: children }));
}
exports.SearchVacanciesProvider = SearchVacanciesProvider;
exports.default = SearchVacanciesContext;
